import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserInfo, Department, CrmUser } from '../../shared/models/user.model';
import { ApiService } from './api.service';

export interface EnvironmentData {
  copyright: string;
  server: string;
  version: string;
  build: string;
  legal: Map<string, string>;
  privacy: Map<string, string>;
  crmAppUrl: string;
  servicesRoot: string;
}

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private baseUrl = this.apiService.getBaseUrl() + 'env/';

  constructor(
    private apiService: ApiService
  ) { }

  getEnvironment(): Observable<EnvironmentData> {
    const url = this.baseUrl;

    return this.apiService.createGetServiceCall<EnvironmentData>(
      url + 'footer-info/',
      ''
    );
  }

  getCrmUser(): Observable<CrmUser> {
    const url = this.baseUrl;

    return this.apiService.createGetServiceCall<CrmUser>(
      url + 'crm-user/',
      ''
    );
  }

  getUserInfo(): Observable<UserInfo> {
    const url = this.baseUrl;

    return this.apiService.createGetServiceCall<UserInfo>(
      url + 'user-info/',
      ''
    );
  }

  getUserFeatures(): Observable<string[]> {
    const url = this.baseUrl;
    return this.apiService.createGetServiceCall<string[]>(
      url + 'user-features/',
      ''
    );
  }

  getUserDepartments(): Observable<Department[]> {
    const url = this.baseUrl;
    return this.apiService.createGetServiceCall<Department[]>(
      url + 'user-departments/',
      ''
    );
  }
}
